/**
 * @fileoverview PATCH handler for the "/api/calculated_filters/:app_group_id/unarchive" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { patchApiCalculatedFiltersAppGroupIdUnarchiveCacheKeys } from "./constants";
import type {
  PatchApiCalculatedFiltersAppGroupIdUnarchiveProps,
  PatchApiCalculatedFiltersAppGroupIdUnarchiveResult,
} from "./types";

export const patchApiCalculatedFiltersAppGroupIdUnarchive = reactQueryMutationAdapter(
  patchApiCalculatedFiltersAppGroupIdUnarchiveCacheKeys,
  (
    props: PatchApiCalculatedFiltersAppGroupIdUnarchiveProps
  ): Promise<PatchApiCalculatedFiltersAppGroupIdUnarchiveResult> => {
    const { app_group_id: appGroupId, calculated_filter_ids: calculatedFilterIds } = props;
    return fetch(
      `/api/calculated_filters/${appGroupId}/unarchive`,
      "PATCH",
      { calculated_filter_ids: calculatedFilterIds },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
